<template>
  <div
    v-for="(item, index) in count"
    :key="index"
    class="tw-h-full tw-block tw-animate-pulse tw-overflow-y-visible game-tile-radius"
    :class="$attrs.class"
  >
    <div class="tw-h-full tw-relative">
      <item-card-stack v-if="isCollectionBrowse" class="-tw-z-2 tw-h-full" />
      <div class="tw-relative tw-w-full mod-util-ratio-16-9">
        <div
          class="tw-size-full tw-absolute tw-top-0 tw-left-0 tw-overflow-hidden game-tile-background-color"
        >
          <font-awesome-icon
            class="tw-absolute tw-fill-current tw-top-1/2 tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2 tw-text-5xl md:tw-text-6xl tw-opacity-30"
            icon="image"
          />
        </div>
      </div>
      <div v-if="!large" class="tw-px-2 lg:tw-px-3 tw-pt-2 lg:tw-pt-3">
        <div class="tw-flex mod-input--height tw-items-center tw-mb-0.5">
          <div
            class="tw-h-2 xss:tw-h-2.5 tw-w-2/3 tw-rounded-full game-tile-background-color"
          ></div>
        </div>

        <div class="tw-flex tw-items-center tw-justify-between tw-pt-3">
          <div class="tw-flex tw-items-center tw-space-x-2">
            <div class="tw-flex tw-space-x-1">
              <div
                class="tw-size-2 tw-rounded-full game-tile-background-color"
              ></div>
              <div
                class="tw-h-2 tw-rounded-full tw-w-6 game-tile-background-color"
              ></div>
            </div>
            <div class="tw-flex tw-space-x-1">
              <div
                class="tw-size-2 tw-rounded-full game-tile-background-color"
              ></div>
              <div
                class="tw-h-2 tw-rounded-full tw-w-6 game-tile-background-color"
              ></div>
            </div>
            <div v-if="isModBrowse" class="tw-flex tw-space-x-1">
              <div
                class="tw-size-2 tw-rounded-full game-tile-background-color"
              ></div>
              <div
                class="tw-h-2 tw-rounded-full tw-w-6 game-tile-background-color"
              ></div>
            </div>
          </div>
        </div>
        <loading-content class="tw-mt-8" />
      </div>
      <loading-button
        v-if="isModBrowse"
        full-width
        medium
        class="tw-mx-2 lg:tw-mx-3 tw-pt-2 lg:tw-pt-3"
      />
    </div>
  </div>
</template>

<script>
import ItemCardStack from '@shared/components/List/ItemCardStack.vue'
import LoadingContent from '@components/Loading/LoadingContent.vue'
import LoadingButton from '@components/Loading/LoadingButton.vue'
import { PAGINATION_DEFAULT_LIMIT } from '@config/options.js'
import { useRoute } from '@composables'
import { computed } from 'vue'
import {
  USER_GAME_COLLECTION_BROWSE_ROUTE,
  USER_COLLECTION_BROWSE_ROUTE,
  COLLECTION_BROWSE_ROUTE,
  USER_MOD_BROWSE_ROUTE,
  MOD_BROWSE_ROUTE,
} from '@config/routeNames.js'

export default {
  components: {
    LoadingContent,
    LoadingButton,
    ItemCardStack,
  },
  inheritAttrs: false,
  props: {
    count: {
      type: Number,
      default: PAGINATION_DEFAULT_LIMIT,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { routeName } = useRoute()

    const isModBrowse = computed(() =>
      [USER_MOD_BROWSE_ROUTE, MOD_BROWSE_ROUTE].includes(routeName.value)
    )
    const isCollectionBrowse = computed(() =>
      [
        USER_GAME_COLLECTION_BROWSE_ROUTE,
        USER_COLLECTION_BROWSE_ROUTE,
        COLLECTION_BROWSE_ROUTE,
      ].includes(routeName.value)
    )

    return {
      isCollectionBrowse,
      isModBrowse,
    }
  },
}
</script>
